const classNames = (...classes: (string | boolean | null | undefined | number)[]) => {
  return classes.filter(c => Boolean(c)).join(' ')
}

export default classNames
